import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getDocumentRequests as onGetDocumentRequests,
    addNewDocumentRequest as onAddNewDocumentRequest,
    updateDocumentRequest as onUpdateDocumentRequest,
    deleteDocumentRequest as onDeleteDocumentRequest,

    getDocumentTypes as onGetDocumentTypes,
    getStudents as onGetStudents,
    
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const DocumentRequest = () => {

    //meta title
    document.title = "Demandes de documents | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [documentRequest, setDocumentRequest] = useState(null);
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            uid: (documentRequest && documentRequest.uid) || '',
            student_id: (documentRequest && documentRequest.student_id) || '',
            document_type_id: (documentRequest && documentRequest.document_type_id) || '',
           
            status: (documentRequest && documentRequest.status) || '',
            
        },
        validationSchema: Yup.object({
           
            student_id: Yup.number().required("Veuillez sélectionner l'étudiant"),
            document_type_id: Yup.number().required("Veuillez sélectionner le type de document"),
           
            status: Yup.string().required("Veuillez sélectionner le statut'"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const documentRequest = {
                    //id: values.id,
                    uid: values.uid,
                    student_id: values.student_id,
                    document_type_id: values.document_type_id,
                   
                    status: values.status,
                    
                };
           
                dispatch(onUpdateDocumentRequest(documentRequest));
                validation.resetForm();
            } else {
                const newDocumentRequest = {
                    //id: values["id"],
                    //uid: values["uid"],
                   
                    student_id: values["student_id"],
                    document_type_id: values["document_type_id"],
                   
                    status: values["status"],
                   
                };
        
                dispatch(onAddNewDocumentRequest(newDocumentRequest));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const DocumentRequestProperties = createSelector(
        (state) => state.documentRequestReducer, 
        (documentRequestReducer) => ({
            documentRequests: documentRequestReducer.documentRequests,
            loading: documentRequestReducer.loading
        })
    );

    const {documentRequests, loading} = useSelector(DocumentRequestProperties);

    const [isLoading, setLoading] = useState(loading)


   

     // Students
    const StudentProperties = createSelector(
        (state) => state.studentReducer, 
        (studentReducer) => ({
            students: studentReducer.students,
            loading: studentReducer.loading
        })
    );

    const {students} = useSelector(StudentProperties);

      // Document types
    const DocumentTypeProperties = createSelector(
        (state) => state.documentTypeReducer, 
        (documentTypeReducer) => ({
            documentTypes: documentTypeReducer.documentTypes,
            loading: documentTypeReducer.loading
        })
    );

    const {documentTypes} = useSelector(DocumentTypeProperties);



    

    useEffect(() => {
        if (documentRequests && !documentRequests.length) {
            dispatch(onGetDocumentRequests());
        }

       

        if (students && !students.length) {
            dispatch(onGetStudents());
        }

         if (documentTypes && !documentTypes.length) {
            dispatch(onGetDocumentTypes());
        }
    }, [dispatch, documentRequests.length,  students.length, documentTypes.length]);



   


    

  

    const toggle = () => {
        if (modal) {
            setModal(false);
            setDocumentRequest(null);
        } else {
            setModal(true);
        }
    };

    const handleDocumentRequestClick = arg => {
        const documentRequest = arg;
        setDocumentRequest({
            id: documentRequest.id,
            uid: documentRequest.uid,
            student_id: documentRequest.student_id,
            structure_id: documentRequest.structure_id,
            teacher_id: documentRequest.teacher_id,
            duration: documentRequest.duration,
            rapport_url: documentRequest.rapport_url,
            status: documentRequest.status,
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (documentRequest) => {
        setDocumentRequest(documentRequest);
        setDeleteModal(true);
    };

    const handleDeleteDocumentRequest = () => {
        if (documentRequest && documentRequest.id) {
            dispatch(onDeleteDocumentRequest(documentRequest));
            setDeleteModal(false);
        }
    };

    const onClickNewDocumentRequest = () => {
        setIsEdit(false);
        setDocumentRequest(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Date",
                accessorKey: "created_at",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Étudiant",
                accessorKey: "student.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Type de document",
                accessorKey: "document_type.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
           

             {
                header: "État",
                accessorKey: "status",
                enableColumnFilter: false,
                enableSorting: true,
            },

            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleDocumentRequestClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteDocumentRequest}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Demandes de documents" breadcrumbItem="Liste des demandes de documents" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewDocumentRequest} className="btn btn-primary me-1">Ajouter une demande de document</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={documentRequests || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Demande de document" : "Ajouter - Demande de document"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                       

                                       



                                        <div className="mb-3">
                                            <Label>Étudiant</Label>
                                            <Input
                                                name="student_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.student_id || ""
                                                }
                                                invalid={
                                                    validation.touched.student_id && validation.errors.student_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {students.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.student_id && validation.errors.student_id ? (
                                                <FormFeedback type="invalid">{validation.errors.student_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Type de document</Label>
                                            <Input
                                                name="document_type_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.document_type_id || ""
                                                }
                                                invalid={
                                                    validation.touched.document_type_id && validation.errors.document_type_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {documentTypes.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.document_type_id && validation.errors.document_type_id ? (
                                                <FormFeedback type="invalid">{validation.errors.document_type_id}</FormFeedback>
                                            ) : null}
                                        </div>



                                         <div className="mb-3">
                                            <Label>État</Label>
                                            <Input
                                                name="status"
                                                type="text"
                                                placeholder="État"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.status || ""}
                                                invalid={
                                                    validation.touched.status && validation.errors.status ? true : false
                                                }
                                            />
                                            {validation.touched.status && validation.errors.status ? (
                                                <FormFeedback type="invalid">{validation.errors.status}</FormFeedback>
                                            ) : null}
                                        </div>
                                       
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default DocumentRequest;